import gql from "graphql-tag";

export const createProgramObjective = gql`
  mutation CreateProgramObjective($data: ObjectiveCreateInput!) {
    createObjective(data: $data) {
      id
    }
  }
`;
